import { Card, useDialog } from "@fpsoftware/mvp";
import { TbEdit } from "react-icons/tb";
import { useParams } from "react-router-dom";
import { formatMoney } from "shared";
import { AddressCard } from "@/addresses/AddressCard";
import { BorrowerCard } from "@/borrower/BorrowerCard";
import { Button } from "@/components/Button";
import { Container } from "@/components/grid/Container";
import { Grid } from "@/components/grid/Grid";
import { AppPage } from "@/layout/AppLayout";
import { EditPurchaseAddressDialog } from "@/purchases/EditPurchaseAddressDialog";
import { EditPurchaseDialog } from "@/purchases/EditPurchaseDialog";
import { usePurchase } from "@/purchases/hooks";
import { PurchaseOfferList } from "@/purchases/PurchaseOfferList";

export const PagePurchaseDetail = () => {
  const { id } = useParams();
  const purchaseID = Number(id);
  const purchase = usePurchase(purchaseID);
  const dialog = useDialog();

  const handleEdit = () => dialog.open(EditPurchaseDialog, { purchase });
  const handleEditAddress = () =>
    dialog.open(EditPurchaseAddressDialog, { purchase });

  return (
    <AppPage title="Purchase detail">
      <Container>
        <Grid className="mb-3">
          <Grid.Col xs={6}>
            <Card>
              <Card.Header>
                Purchase details
                <Button size="sm" icon={TbEdit} onClick={handleEdit}>
                  Edit
                </Button>
              </Card.Header>
              <Card.List>
                <Card.ListItem label="Mortgage type">
                  {purchase.mortgageType}
                </Card.ListItem>
                <Card.ListItem label="Price">
                  {formatMoney(purchase.price)}
                </Card.ListItem>
                <Card.ListItem label="Downpayment">
                  {formatMoney(purchase.downpayment)}
                </Card.ListItem>
                <Card.ListItem label="Earnest">
                  {formatMoney(purchase.earnest)}
                </Card.ListItem>
                <Card.ListItem label="Funding date">
                  {purchase.fundingDate}
                </Card.ListItem>
                <Card.ListItem label="Annual insurance">
                  {formatMoney(purchase.annualInsurance)}
                </Card.ListItem>
                <Card.ListItem label="Annual HOA">
                  {formatMoney(purchase.annualHOA)}
                </Card.ListItem>
                <Card.ListItem label="Note">
                  {purchase.note || <i>No note provided.</i>}
                </Card.ListItem>
              </Card.List>
            </Card>
          </Grid.Col>
          <Grid.Col xs={6}>
            {purchase.addressID === null ? (
              <Card className="mb-3">
                <Card.Header>
                  Property
                  <Button size="sm" icon={TbEdit} onClick={handleEditAddress}>
                    Edit
                  </Button>
                </Card.Header>
                <Card.List>
                  <Card.ListItem label="Address">TBD</Card.ListItem>
                  <Card.ListItem label="Annual tax">
                    {formatMoney(purchase.annualTax)}
                  </Card.ListItem>
                </Card.List>
              </Card>
            ) : (
              <AddressCard
                addressID={purchase.addressID}
                className="mb-3"
                onEdit={handleEditAddress}
              />
            )}
            <BorrowerCard borrowerID={purchase.clientID} />
          </Grid.Col>
        </Grid>
        <hr />
        <PurchaseOfferList purchaseID={purchaseID} />
      </Container>
    </AppPage>
  );
};
